/* eslint-disable react/prop-types */
import { WaveRating, GlobeRating } from '@bwoty-web/styleguide';
import Title from '../../../common/title';
import Subtitle from '../../../common/subtitle';
import KeySellingPointList from '../../../common/keySellingPointList';
import './titles.scss';

const Titles = ({ siteId, hotelName, rating, geographical, usps }) => {
  const Rating = siteId === 18 ? GlobeRating : WaveRating;

  return (
    <div className="gw-hotel-info-titles__wrapper">
      <div className="gw-hotel-info-titles">
        <div className="gw-hotel-info-titles__title-rating-container">
          <Title className="gw-hotel-info-titles__title">{hotelName}</Title>
          <Rating
            className="gw-hotel-info-titles__hotel-standard"
            rating={rating}
            responsive
            siteId={siteId}
          />
          <Subtitle
            className="gw-hotel-info-titles__subtitle"
            geographical={geographical}
          />
        </div>

        <KeySellingPointList
          ksps={usps}
          className="gw-hotel-info-titles__key-selling-points"
        />
      </div>
    </div>
  );
};

export default Titles;
